import { BrowserRouter as Router,Route,Switch } from "react-router-dom";
import Home from "./Views/Home";
import AboutUs from "./Views/AboutUs";
import Blogs from "./Views/Blogs";
import CommercialMoving from "./Views/CommercialMoving";
import ContactUs from "./Views/ContactUs";
import FAQs from "./Views/FAQs";
import LocalMoving from "./Views/LocalMoving";
import LongDistanceMoving from "./Views/LongDistanceMoving";
import LongDistanceMovingTips from "./Views/LongDistanceMovingTips";
import MilitaryMoving from "./Views/MilitaryMoving";
import OurService from "./Views/OurService";
import PackingAndUnpacking from "./Views/PackingAndUnpacking";
import PianoAndAntique from "./Views/PianoAndAntique";
import StorageS from "./Views/Storage";
import Login from "./Views/Login";
import FormDatas from "./Views/FormDatas";
import PrivacyPolicy from "./Views/PrivacyPolicy";
import CopyRights from "./Views/CopyRights";
import Testimonials from "./Views/Testimonials";
import SocialPolicy from "./Views/SocialPolicy";
import MovingPlanner from "./Views/MovingPlanner";

function Routers() {
    return (
        <div>
            <Router>
                <Switch>
                    <Route exact path='/' component={Login} />
                    <Route path='/Home' component={Home} />
                    <Route path='/AboutUs' component={AboutUs} />
                    <Route path='/Blogs' component={Blogs} />
                    <Route path='/CommercialMoving' component={MilitaryMoving} />
                    <Route path='/ContactUs' component={ContactUs} />
                    <Route path='/FAQs' component={FAQs} />
                    <Route path='/LocalMoving' component={LocalMoving} />
                    <Route path='/LongDistanceMoving' component={LongDistanceMoving} />
                    <Route path='/LongDistanceMovingTips' component={LongDistanceMovingTips} />
                    {/* <Route path='/MilitaryMoving' component={MilitaryMoving} /> */}
                    <Route path='/OurService' component={OurService} />
                    <Route path='/PackingAndUnpacking' component={PackingAndUnpacking} />
                    <Route path='/PianoAndAntique' component={PianoAndAntique} />
                    <Route path='/Storage' component={StorageS} />
                    <Route path='/FormView' component={FormDatas} />
                    <Route path='/PrivacyPolicy' component={PrivacyPolicy} />
                    <Route path='/Copyright' component={CopyRights} />
                    <Route path='/Testimonials' component={Testimonials} />
                    <Route path='/socialMediaPolicy' component={SocialPolicy} />
                    <Route path='/MovingPlanner' component={MovingPlanner} />
                </Switch>
            </Router>
        </div>
    )
}

export default Routers
